<mat-toolbar class="subtitulo">Cadastro Bens Permanente e de Consumo</mat-toolbar>

<div class="painel-principal" style="padding: 10px;">
     <form #formCadastro="ngForm">

          <!-- DADOS INICIAIS -->
          <mat-toolbar class="titulopartes">Dados Iniciais</mat-toolbar>
          <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
               
               <mat-form-field fxFlex="20%" fxFlexOffset="20px">
                    <mat-label >Tipo:</mat-label>
                    <mat-select fxFlexOffset="20px" [(ngModel)]="material.tipo" name="tipo" required>
                         <mat-option></mat-option>
                         <mat-option *ngFor="let d of tipos" [value]="d.id">
                              {{d.descricao}}
                         </mat-option>
                    </mat-select>
               </mat-form-field>
          
               <mat-form-field fxFlex="70%">
                    <input #nome matInput maxlength="200" name="nome" placeholder="Nome do Bem:"
                         [(ngModel)]="material.nome" required>
                    <mat-hint align="end">{{nome.value.length}} / 200</mat-hint>
               </mat-form-field>

          </div>
          <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
               <mat-form-field fxFlex="15%" fxFlexOffset="20px">
                    <input type=number #qtdLimite [(ngModel)]="material.quantidadeLimitePedido" 
                           matInput min=0 name="quantidadeLimitePedido" placeholder="Quantidade limite:" />
               </mat-form-field>
              
               <mat-form-field fxFlex="15%">
                    <input type=number [(ngModel)]="material.numeroVidaUtil" 
                           #qtdLimite matInput min=0 name="numeroVidaUtil" placeholder="Vida Útil (Meses):" />
               </mat-form-field>

               <mat-form-field fxFlex="20%">
                    <input type=number min=0 matInput [(ngModel)]="material.valorDepreciacao" 
                           name="valorDepreciacao" placeholder="Depreciação Ano:">
                    <span matSuffix>%</span>
                </mat-form-field>
          </div>

          <!--UNIDADE -->
          <mat-toolbar class="titulopartes">Unidade</mat-toolbar>
          <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

               <mat-form-field fxFlex="35%" fxFlexOffset="20px">
                    <input #codigoUnidadeMedida matInput maxlength="20" name="codigoUnidadeMedida" placeholder="Código Unidade Medida:"
                         [(ngModel)]="material.codigoUnidadeMedida">
                         <mat-hint align="end">{{codigoUnidadeMedida.value.length}} / 20</mat-hint>
               </mat-form-field>

               <mat-form-field style="margin: 0 0 0 20px" fxFlex="60%" appearance="outline">
                    <mat-label>Descrição Unidade Medida:</mat-label>
                    <textarea #observacoes matInput name="observacoes" [(ngModel)]="material.descricaoUnidadeMedida" cdkTextareaAutosize
                        #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" maxlength="200"></textarea>
                        <mat-hint align="end">{{observacoes.value.length}} / 200</mat-hint>
                </mat-form-field>

          </div>

          <!--NOTA FISCAL -->
          <mat-toolbar class="titulopartes">Nota Fiscal</mat-toolbar>
          <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

               <mat-form-field fxFlex="50%" fxFlexOffset="20px">
                    <input  #nomeMaterialNotafiscal  matInput maxlength="200" name="nomeMaterialNotafiscal" placeholder="Nome Bem na Nota Fiscal:"
                         [(ngModel)]="material.nomeNotaFiscal">
                         <mat-hint align="end">{{nomeMaterialNotafiscal.value.length}} / 200</mat-hint>
               </mat-form-field>

          </div>

          <!-- BOTOES -->
          <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
               fxFlexFill>
               <button *ngIf="!isAtualizar && mostrarBotaoCadastrar" mat-raised-button name="botaoConfirmar"
                    fxFlex="20%" color="primary" [disabled]="formCadastro.invalid" (click)="cadastrar()"> Cadastrar
               </button>

               <button *ngIf="isAtualizar && mostrarBotaoAtualizar" mat-raised-button name="botaoConfirmar" fxFlex="20%"
                    color="primary" [disabled]="formCadastro.invalid" (click)="atualizar()">
                    Atualizar
               </button>

               <button *ngIf="mostrarBotaoLimpar()" mat-raised-button fxFlex="20%" (click)="limpar()">
                    Limpar
               </button>
               <button mat-raised-button fxFlex="20%" (click)="cancelar()">
                    Cancelar
               </button>

          </div>
     </form>


</div>